import { WizardBanner } from '@iheartjane/menu';
import type { ComponentProps } from 'react';
import { useEffect } from 'react';

import { useWizardExposure } from './wizardExposureContext';

export function BloomWizardBanner(props: ComponentProps<typeof WizardBanner>) {
  const { markExposed } = useWizardExposure();

  useEffect(() => {
    markExposed();
  }, [markExposed]);

  return <WizardBanner {...props} />;
}
